
import React, {useEffect, useRef} from 'react';
import {DocumentTextIcon} from '@heroicons/react/outline';

import {cx} from '../util';

const speakerLabels = {
  ai: 'Interviewer', // deprecated
  user: 'You', // deprecated
  interviewer: 'Interviewer',
  candidate: 'You',
};

export const TranscriptItems = ({transcript}) => (
  <div className="space-y-4">
    {(transcript || []).map((item, index) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={cx('flex gap-3', speakerLabels[item.speaker] === 'You' ? 'justify-end' : 'justify-start')}
      >
        <div className={cx('max-w-[80%] px-4 py-2 rounded-lg text-sm',
          speakerLabels[item.speaker] === 'You'
            ? 'bg-blue-500 text-white rounded-br-sm'
            : 'bg-gray-100 text-gray-900 rounded-bl-sm')}
        >
          <div className="font-medium text-xs mb-1 opacity-75">
            {speakerLabels[item.speaker]}
          </div>
          <div>{item.transcript}</div>
        </div>
      </div>
    ))}
  </div>
);

const LiveTranscript = ({transcript, className}) => {
  const scrollRef = useRef(null);

  // Auto-scroll to bottom when new transcript items are added
  useEffect(() => {
    if (scrollRef.current) {
      scrollRef.current.scrollTo({
        top: scrollRef.current.scrollHeight,
        behavior: 'smooth',
      });
    }
  }, [transcript]);

  return (
    <div className={cx('h-full flex-1 overflow-y-auto', className)} ref={scrollRef}>
      {transcript && transcript.length > 0
        ? <TranscriptItems transcript={transcript} />
        : (
          <div className="flex flex-col items-center justify-center h-full text-gray-500">
            <DocumentTextIcon className="h-12 w-12 mb-4 opacity-50" />
            <p className="text-center">
              The transcript will appear here
              <br />
              once the conversation begins
            </p>
          </div>
        )}
    </div>
  );
};

export default LiveTranscript;
